<template>
  <v-list-item @click="detail(order)" class="order-item py-5">
    <div class="item-body">
      <div class="item-title">
        <div class="item-title-inner">
          <v-list-item-title>
            <span>
              Bestellung {{ order.Nummer }}
            </span>
            <v-chip v-if="(order.AnzahlLieferungen ?? 0) > 0" size="x-small" class="px-2">
              <v-icon class="mr-1">mdi-truck-delivery</v-icon>{{ order.AnzahlLieferungen }}
            </v-chip>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span></span>
            <span class="text-grey">{{ order.Lieferant.LieferantName }}
              <small v-if="order.Lieferant.LieferantNr">{{ order.Lieferant.LieferantNr }}</small>
            </span>
          </v-list-item-subtitle>
          <div class="mt-3">
            <v-chip
              v-if="order.Termine.GeplantLieferDatumDate"
              class="px-1"
              :color="order.color"
              variant="outlined"
            >
              <v-avatar class="mr-2" :color="order.color" size="small" />
              <small class="status-info">
                <div><strong>{{ order.statusText }}</strong></div>
                <div>{{ order.Termine.GeplantLieferDatumDate }}</div>
              </small>
              <v-icon class="mx-1" size="16">{{ order.icon }}</v-icon>
            </v-chip>
          </div>
        </div>
        <div class="item-title-delivery-date">
          <v-list-item-subtitle>
            <div>
              {{ order.date }}
              {{ order.time }}
            </div>
          </v-list-item-subtitle>
        </div>
      </div>
    </div>
  </v-list-item>
</template>

<script setup lang="ts">
import Order from '@/model/Order';
import {useRouter} from 'vue-router';

defineProps({
  order: {
    type: Order,
    required: true,
  },
});
const router = useRouter();
function detail(order: Order) {
  router.push({name: 'order_delivery', params: {id: `${order.Nummer}`}}).catch(console.error);
};
defineExpose({detail});
</script>

<style lang="scss" scoped>

.v-chip .v-icon {
  font-size: 16px;
}

.item-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .item-title {
    display: flex;
    justify-content: space-between;
    flex: 1;
    flex-wrap: wrap;

    .item-title-delivery-date {
      margin-top: 0.25rem;
    }
  }
}
.item-operator-info {
  display: flex;
  justify-content: stretch;
  align-items: center;
  text-align: center;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  flex: auto;
  .v-chip__content {
    display: block;
  }
  .primary {
    color: #fff;
  }
  .v-chip {
    text-align: left;
  }
  .item-operator-info-inner {
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex: auto;
    .v-list-item__subtitle {
      font-size: 12px;
      line-height: 1;
      overflow: visible;
    }
  }
}
.item-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

.v-list-item {
  display: block;
  overflow: hidden;
}
.v-chip.theme--light {
  &.red {
    color: #fff;
  }
}
.v-chip.v-size--default {
  font-size: 12px;
}
.item-progress-bar {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
}

.status-info {
  line-height: 130%;
}
</style>
